var exports = {
  "kL": "xcc377c0b--e39a49--container",
  "U9": "xcc377c0b--e39a49--count",
  "Kk": "xcc377c0b--e39a49--icon",
  "nf": "xcc377c0b--e39a49--link",
};

module.exports = exports;
